export enum EReportTypes {
  User = 'user',
  Card = 'pick',
  List = 'list',
  Invite = 'invite',
  Thought = 'thought',
  Chat = 'thread',
  Spark = 'spark',
}
